import { LessonAction } from "@/harness/harness.types";
import { requestLessonActions, evaluateAnswer } from "@/services/ai/client";

/**
 * AI Engine — thin wrapper the Harness talks to. All prompt-building,
 * retry, and fallback logic actually lives server-side in
 * functions/api/lesson.ts and functions/api/evaluate.ts (so the
 * Mistral key never reaches the browser); this class is the
 * Harness-facing seam so that seam can be swapped/mocked in tests.
 */
export class AiEngine {
  async requestLessonActions(topic: string, priorMistakes: string[] = []): Promise<LessonAction[]> {
    return requestLessonActions(topic, priorMistakes);
  }

  async evaluateAnswer(question: string, answer: string) {
    return evaluateAnswer(question, answer);
  }
}
